import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Buffer } from 'buffer';
import './pdf-viewer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Set the workerSrc for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = ({ fileBuffer }) => {
  const [numPages, setNumPages] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const toBase64 = (data) => {
    return Buffer.from(data, 'binary').toString('base64');
  };

  return (
    <div key={fileBuffer ? fileBuffer.length : 'no-buffer'}>
      <div
        className="pdf-viewer"
        style={{
          flex: 1,
          overflow: 'hidden',
        }}
      >
        <Document file={`data:application/pdf;base64,${toBase64(fileBuffer)}`} onLoadSuccess={onDocumentLoadSuccess}>
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={3} />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default PdfViewer;
